import * as yup from 'yup';
import I18n from 'services/I18n';

export const emailSchema = yup
    .string()
    .email(I18n.t('validation.email.invalid'))
    .max(180, I18n.t('validation.email.tooLong', {number: 180}));
